import React from "react";
import PropTypes from "prop-types";
import MyModal from "./utilities/MyModal.jsx";

async function addGammaNetwork() {
  try {
    const result = await window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: "0x1EFD", // 7933
          rpcUrls: ["https://gethrpc.gammaoptions.com/"],
          chainName: "GammaNet",
          nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18
          },
          blockExplorerUrls: null
        }
      ]
    });
  } catch (error) {
    console.log("There was an error adding GammaNet to your wallet.");
    console.log(error);
  }
}

export const noContractsOnCurrentNetworkErrMessage = (
  <>
    We are currently in a beta testing phase on our own private network. To use our app, please change the network to GammaNet in your wallet.
    <br /> <br />
    Click the button below to easily add GammaNet to your wallet, or follow the <nbsp />
    <a
      href="https://gamma-options.gitbook.io/docs/getting-started/setup-gammanet"
      style={{ color: "#09b9e6", textDecoration: "none" }}
      target="_blank"
      rel="noreferrer"
    >
      setup GammaNet
    </a>
    <nbsp /> tutorial to add it manually. <br /> <br />
    <button className="addGammaNetToWalletButton" onClick={() => addGammaNetwork()}>
      Add GammaNet To Your Wallet
    </button>
  </>
);

class BreakingErrorModal extends React.Component {
  render() {
    const isEmptyMessage = this.props.message === "";
    return (
      <MyModal isOpen={this.props.isOpen} isUnclosable>
        <div
          id="errorModal"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {!isEmptyMessage && <img className="errorImg" />}
          {isEmptyMessage ? (
            <span className="welcomeText">WELCOME TO GAMMA OPTIONS</span>
          ) : (
            <span className="errorRedMessage">OOOPS, SOMETHING WENT WRONG</span>
          )}
          <span className="errorWhiteMessage">{isEmptyMessage ? noContractsOnCurrentNetworkErrMessage : this.props.message}</span>
        </div>
      </MyModal>
    );
  }
}

BreakingErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired
};

export default BreakingErrorModal;
